const RoutePaths = {
  home: '/',

  internalusers: '/internalusers',
  internalusersDetail: '/internalusers/:id',
  internalusersDetailClaims: '/internalusers/:id/claims',
  internaluserDelete: '/internalusers/:id/delete',

  externalusers: '/externalusers',
  externalusersDetail: '/externalusers/:id',
  externalusersDetailClaims: '/externalusers/:id/claims',
  externaluserDelete: '/externalusers/:id/delete',

  applications: '/applications',
  applicationsAdd: '/applications/add',
  applicationsDetail: '/applications/:id',

  clearCookies: '/clear-cookies',

  roles: '/roles',
  rolesAdd: '/roles/add',
  rolesDetail: '/roles/:id',
  roleSecurityGroup: '/roles/:id/security-group',

  accessrequests: '/accessrequests',
  accessrequestsDetail: '/accessrequests/:id',

  approvedAccesses: '/user-access/approved',

  permissions: '/permissions',
  permissionsAdd: '/permissions/add',
  permissionsDetail: '/permissions/:id',
  permissionSecurityGroup: '/permissions/:id/security-group',

  organizationgroups: '/organizationgroups',
  organizationgroupsAdd: '/organizationgroups/add',
  organizationgroupsDetail: '/organizationgroups/:id',

  sectionsadgroups: '/sectionsadgroups',
  sections: '/sectionsadgroups/sections',
  sectionsDetail: '/sectionsadgroups/sections/:id',
  adgroups: '/sectionsadgroups/adgroups',
  adgroupsDetail: '/sectionsadgroups/adgroups/:id',

  auditlogs: '/auditlogs',
  auditlogsDetail: '/auditlogs/:id',

  uiTexts: '/uitexts',

  devTools: '/devtools',

  hangfireDashboard: '/hangfire'
} as const;

export default RoutePaths;
